import { render, staticRenderFns } from "./BaseOverlayWrapper.vue?vue&type=template&id=4585af58&scoped=true&"
var script = {}
import style0 from "./BaseOverlayWrapper.vue?vue&type=style&index=0&id=4585af58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585af58",
  null
  
)

export default component.exports